import { Pipe, PipeTransform } from '@angular/core';
import { OrderOutputFormat } from '@app/shared/enums/OrderOutputFormat';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'orderOutputFormat',
    standalone: false
})
export class OrderOutputFormatPipe implements PipeTransform {
  public orderGenerationType = OrderOutputFormat;

  constructor(public translate: TranslateService) { }

  transform(value: any): string {
    if (value === null || value === undefined) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const outputFormats = Array.isArray(value) ? value : [value];

    if (outputFormats.length === 0) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const translatedStates = outputFormats
      .map(outputFormat => {
        const key = Object.keys(OrderOutputFormat).find(
          k => OrderOutputFormat[k as keyof typeof OrderOutputFormat] === outputFormat
        );
        return key ? this.translate.instant(`ENUMS.${key}`) : null;
      })
      .filter(Boolean);

    return translatedStates.length > 0
      ? translatedStates.join(', ')
      : this.translate.instant('ENUMS.NO_STATE');
  }
}
